<con-app
  [accountLabel]="account.name"
  [accountIcon]="accountIcon"
  [sideNavCollection]="links"
  [companyName]="'AVEVA'"
  [appName]="'Unified Engineering'"
  [logoImage]="''"
  [helpButtonLink]="'https://docs.aveva.com/bundle/e-ue-connect/page/1372527.html'"
>
</con-app>
